<template>
  <div class="sales-report-list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="row mt-2">
            <div class="col-sm-10 col-form-label report-title">
              <span class="title-green">{{ $t("report.coupon_reports") }}&nbsp</span>/<span class="title-black">&nbsp{{ $t("report.sales_report") }}</span>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-card class="mt-2">
            <b-col cols="12" class="d-flex justify-content-center align-items-center">
              <div class="col-4 sales-hut-selection">
                <multiselect v-model="selectedOutlets" :options="allStoresList" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" :placeholder="$t('report.select_huts')" label="name_en" track-by="name_en" :preselect-first="true">
                  <template slot="selection" slot-scope="{ values, search, isOpen }">
                    <span class="multiselect__single" v-if="values.length && !isOpen" ref="hutSearch">
                      <!-- {{ values.length }} options selected -->
                      {{getSpanText(values)}}
                    </span>
                  </template>
                </multiselect>
              </div>
              <div class="col-4">
               <fieldset class="date-range-box-order-sales-reports">
                  <legend class="date-range-text">{{ $t('report.filter_date_range_text') }}</legend>
                  <b-input-group style="border: none !important;">
                    <date-range-picker ref="drange" :startDate="filter.startAt" :endDate="filter.endAt" @update="updateDateRange" opens="left" :locale-data="date_locale" :ranges="ranges"></date-range-picker>
                  </b-input-group>
                </fieldset>
              </div>
              <div class="col-4 text-center">
                <vue-json-to-csv :json-data="reportExportData" :labels="reportExportDataTitles" :csv-title="`Sales_Summary_${this.filter.startAt}_${this.filter.endAt}`" >
                  <button :disabled="total_transactions < 1" class="btn btn-success">{{ $t('common.export_csv') }}</button>
                </vue-json-to-csv>
              </div>
            </b-col>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <div class="report-card">
            <md-card md-with-hover>
              <md-ripple>
                <md-card-header>
                  <div class="md-title card-number-stats" style="margin-top: 50px"><strong>{{currency.symbol_native}}{{total_sales}} {{currency.code}}</strong></div>
                </md-card-header>
                <md-card-content>{{ $t('report.card_total_sales') }}</md-card-content>
                <md-card-actions style="margin-top: 35px"></md-card-actions>
              </md-ripple>
          </md-card>
          </div>
        </b-col>

        <b-col>
          <div class="report-card">
            <md-card md-with-hover>
              <md-ripple>
                <md-card-header>
                  <div class="md-title card-number-stats" style="margin-top: 50px"><strong>{{total_transactions}}</strong></div>
                </md-card-header>
                <md-card-content>
                  {{ $t('report.card_total_transactions') }}
                </md-card-content>
                <md-card-actions style="margin-top: 35px"></md-card-actions>
              </md-ripple>
          </md-card>
          </div>
        </b-col>

        <b-col>
          <div class="report-card">
            <md-card md-with-hover>
              <md-ripple>
                <md-card-header>
                  <div class="md-title card-number-stats" style="margin-top: 50px"><strong>{{currency.symbol_native}}{{aov_value}} {{currency.code}}</strong></div>
                </md-card-header>
                <md-card-content>
                  {{ $t('report.card_average_order_value') }}
                </md-card-content>
                <md-card-actions style="margin-top: 35px"></md-card-actions>
              </md-ripple>
          </md-card>
          </div>
        </b-col>

      </b-row>

      <b-row class="mt-4">

        <b-col>
          <div class="report-card">
            <md-card md-with-hover>
              <md-ripple>
                <md-card-header>
                  <div class="md-title card-heading-stats">{{ $t('report.card_sales_channel_distribution') }}</div>
                </md-card-header>
                <md-card-content>
                  <div class="card-pie-chart">
                    <PieChart :height="250" :chartData="salesChannelDistributionChartData" :options="options"></PieChart>
                  </div>
                </md-card-content>
              </md-ripple>
          </md-card>
          </div>
        </b-col>

        <b-col>
          <div class="report-card">
            <md-card md-with-hover>
              <md-ripple>
                <md-card-header>
                  <div class="md-title card-heading-stats">{{ $t('report.payment_method_distribution') }}</div>
                </md-card-header>
                <md-card-content>
                  <div class="card-pie-chart">
                    <PieChart :height="250" :chartData="paymentMethodChartData" :options="paymentDistributionChartOptions"></PieChart>
                  </div>
                </md-card-content>
              </md-ripple>
          </md-card>
          </div>
        </b-col>

        <b-col>
          <div class="report-card">
            <md-card md-with-hover>
              <md-ripple>
                <md-card-header>
                  <div class="md-title card-heading-stats">{{ $t('report.delivery_vs_collection') }}</div>
                </md-card-header>
                <md-card-content>
                  <div class="card-pie-chart">
                    <PieChart :height="250" :chartData="deliveryAndCollectionChartData" :options="paymentDistributionChartOptions"></PieChart>
                  </div>
                </md-card-content>
              </md-ripple>
          </md-card>
          </div>
        </b-col>

      </b-row>

      <b-row class="mt-4 mb-2 last-row">
        <b-col cols="6">
          
          <template v-if="overviewTableData.items.length">
            <md-table v-model="overviewTableData.items" md-card >
                <md-table-toolbar>
                  <h1 class="md-title report-card card-heading-stats">{{ $t('report.header_overview') }}</h1>
                </md-table-toolbar>

              <md-table-row class="mb-3 mt-4">
                <md-table-head
                  v-for="field in overviewTableData.fields"
                  :key="field.name">
                  <span class="totals-row">{{ $t(field.label) }}</span>
                </md-table-head>
              </md-table-row>

                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell
                    v-for="(field, index) in overviewTableData.fields"
                    :key="index"
                    :md-label="$t(field.label)" >
                    <span
                      v-html="handleShowValue(field, item)"
                      :class="{'totals-row': item.channel == overviewTableData.items[overviewTableData.items.length-1].channel}"
                    >
                    </span>
                  </md-table-cell>

                </md-table-row>

              </md-table>
          </template>
        </b-col>

        <b-col cols="6">
          <div class="md-card report-card last-row">
            <md-card md-with-hover>
                <md-card-header>
                  <div class="md-title card-heading-stats">{{ $t('report.compared_to_previous_year') }}</div>
                </md-card-header>
                <md-card-content class="mt-1">
                  <div>
                    <div class="md-layout-item bar-chart-select-option mt-2">
                      <multiselect 
                        v-model="previousYearOptionSelected" 
                        :options="previousYearFilters" 
                        :multiple="false" 
                        :close-on-select="true" 
                        :clear-on-select="false"    
                        :preselect-first="true"
                        :allow-empty="false"
                        :select-label="''"
                        :deselect-label="''"
                        :open-direction="'bottom'"
                        :placeholder="$t('report.select_option')"
                        label="label"
                        @input="updateComparedToPreviousYearChartData"
                      >
                      </multiselect>
                    </div>
                  </div>
                  <div class="card-pie-chart mt-2" v-if=" 'datasets' in comparedToPreviousYearChartData && comparedToPreviousYearChartData.datasets[0].data.length">
                    <BarChart :height="300" :chartData="comparedToPreviousYearChartData" :options="comparedToPreviousYearChartOption"></BarChart>
                  </div>
                  <div v-else>
                    <md-card-header class=" d-flex justify-content-center align-items-center mb-2" style="height: 220px">
                      <div class="md-title card-heading-stats">{{ $t('report.no_data') }} </div>
                    </md-card-header>
                  </div>
                </md-card-content>
            </md-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import PieChart from '@/components/Partials/PieChart'
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
import Multiselect from 'vue-multiselect';
import SelectDropdown from '../../../components/Partials/SelectDropdown';
import BarChart from '../../../components/Partials/BarChart.vue';
import VueJsonToCsv from 'vue-json-to-csv';

let vm=null;
const LABEL_OTHERS='Others';
const TOTAL_CHEQUE = 'Total Cheque';
const TOTAL_SALE = 'Total Sales';
const AVG_CHEQUE = 'Avg Cheque';

export default {
  name: 'NewSalesReport',
  components: {
    DateRangePicker,
    PieChart,
    Multiselect,
    SelectDropdown,
    BarChart,
    VueJsonToCsv
},
  data: function () {
    return {
        allStoresList: [],
        selectedOutlets: [],
        previousYearFilters : [
          {name: TOTAL_CHEQUE,label: this.$t('report.label_transactions')},
          {name: TOTAL_SALE,label: this.$t('report.label_sales')},
          {name: AVG_CHEQUE, label: this.$t('report.card_average_order_value')}
        ],
        previousYearOptionSelected: '',
        filter: {
            startAt: this.$moment().format('YYYY-MM-DD'),
            endAt: this.$moment().format('YYYY-MM-DD')
        },
        total_sales:0,
        total_transactions:0,
        aov_value: 0,
        salesChannelDistributionChartData: {},
        paymentMethodChartData: {},
        deliveryAndCollectionChartData: {},
        comparedToPreviousYearChartData : {},
        salesChannelData:{},
        previousYearData:{},
        computedLabelsForPreviousYearChart:{},
        overviewTableData: {
          items: [],
          fields: [
            {
              name:"channel",
              label: 'report.label_sales_channel'
            },
            {
              name:"transaction",
              label: 'report.label_transactions'
            },
            {
              name:"sales",
              label: 'report.label_sales',
              customValue: (item) => {
                return item.sales+' '+vm.currency.code;
              }
            },
            {
              name:"AOV",
              label: 'report.label_aov',
              customValue: (item) => {
                return item.AOV+' '+vm.currency.code;
              }
            }
          ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
            
            },
            legend : {
                position: "right"
            }
        },
        paymentDistributionChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                let nameWithoutPercentage = data['labels'][tooltipItem['index']].replace(/[\W\d]/g, "");
                if(nameWithoutPercentage == LABEL_OTHERS) {
                  return data['datasets'][0]['label'];
                } else {
                  return `${nameWithoutPercentage} : ${data['datasets'][0]['data'][tooltipItem['index']]}`;
                }
              }
            }
          },
          legend : {
            position: "right"
          }
        },
        currency: this.$store.getters.config.gms.currency_info,
        comparedToPreviousYearChartOption : {
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: 'Y',
          scales: {
            yAxes: [
              {
                ticks: {
                  display: true, // this will remove only the label
                  fontSize: 14,
                },
                gridLines: {
                  display: false,
                  drawOnChartArea: false,
                  drawBorder: false
                },
                grid: {
                  offset: true
                },
                position: 'left',
              },
              {
                type: 'category',
                offset: true,
                ticks: {
                  display: true, // this will remove only the label
                  beginAtZero: true,
                  reverse: true,
                  fontSize: 14,
                  callback: function(label, index, labels) {
                    return [vm.computedLabelsForPreviousYearChart[label].current,vm.computedLabelsForPreviousYearChart[label].previous];
                  }
                },
                gridLines: {
                  display: false,
                },
                grid: {
                  offset: true
                },
                position: 'right',
              }
            ],
            xAxes: [
              {
                ticks: {
                  display: false, // this will remove only the label
                  beginAtZero: true
                },
                gridLines: {
                  display: true,
                  drawOnChartArea: true,
                  drawBorder: false
                },
                grid: {
                  offset: true
                }
              }
            ]
          },
          legend: {
            display: true,
            position:"bottom"
          }
        },
        reportExportData:[],
        reportExportDataTitles: {
          OrderSummaryCategory: { title: 'Summary' }, 
          TotalSale: { title: 'Total Sale' },
          TotalCheque: { title: 'Total Cheque' },
          AverageCheque: { title: 'Average Cheque' },
          OSDSeparator1: { title: '' },
          OrderSummaryDetailsCategory: { title: 'Mobile vs Desktop' },
          OrderType: { title: 'Order Type' },
          Device: { title: 'Device' },
          TotalDetailCheque: { title: 'Total Cheque' },
          TotalDetailSale: { title: 'Total Sales' },
          TotalDetailAvgCheque: { title: 'Avg Cheque' },
          OSDSeparator2: { title: '' },
          ChannelCategory: { title: 'Delivery/Carryout'},
          COrderType: { title: 'Order Type' },
          CTotal: { title: 'Total' },
          CInPercentage: { title: 'In Percentage' },
          OSDSeparator3: { title: '' },
          OrderSummaryPmDetailsCategory: { title: 'Payment Methods' },
          PaymentMethodName: { title: 'Payment Method' },
          PaymentMethodTotal: { title: 'Total' },
          PaymentMethodInPercentage: { title: 'In Percentage' },
        },
        delivery_carryout: null,
        payment_method: null,
        summary: null,
        useNewAPI: false
    }
  },
  methods : {
    handleShowValue(field, item) {
      return field.hasOwnProperty('customValue')
                      ? field.customValue(item)
                      : item[field.name]
    },
    getNewSalesReportData() {
        vm.getOutletList();
        vm.refreshReportCards();
    },
    refreshReportCards() {
        const params = vm.getParams()
        if(vm.useNewAPI) {
          vm.axios.campaign.getNewSalesOrderReportData(params, (response) => {
            vm.loadDataFromAPI(response.data)
          })
        } else {
          vm.axios.campaign.getNewSalesReportData(params, (response) => {
            vm.loadDataFromAPI(response.data)
          })
        }
    },
    loadReportCards() {
      vm.previousYearFilters = [
        {name: TOTAL_CHEQUE,label: vm.$t('report.label_transactions')},
        {name: TOTAL_SALE,label: vm.$t('report.label_sales')},
        {name: AVG_CHEQUE, label: vm.$t('report.card_average_order_value')}
      ]
      vm.previousYearFilters.forEach((item) => {
        if(item.name === vm.previousYearOptionSelected.name) {
          vm.previousYearOptionSelected = item
        }
      })
      vm.getSalesChannelDistributionData()
      vm.updateDeliveryCarryoutData(vm.delivery_carryout)
      vm.updateTransactionsData(vm.payment_method)
      vm.updateOverviewTableData();
      vm.updateComparedToPreviousYearChartData();
      vm.prepareDataForExport(vm.summary, vm.salesChannelData, vm.payment_method, vm.delivery_carryout);
    },
    formatPrice(value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    getParams() {
        let _data = {
          start: this.filter.startAt,
          end: this.filter.endAt,
        }

        if(!vm.useNewAPI) {
          _data = {
            start: this.$moment(this.filter.startAt + ' 00:00:00').utc().format('YYYY-MM-DD HH:mm:ss'),
            end: this.$moment(this.filter.endAt + ' 23:59:59').utc().format('YYYY-MM-DD HH:mm:ss'),
          }
        }
  
        if (vm.selectedOutlets.length > 0) {
          let dataOutlets = vm.selectedOutlets.map(item => item.id).join(",");
          _data.outlets = dataOutlets;
        }

        let params = ''
        for (let key in _data) {
          params += key+'='+_data[key]+'&'
        }

        params = params.slice(0, -1)

        return params
    },
    updateDateRange(val) {
      this.filter.startAt = val.startDate != null ? this.$moment(val.startDate).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD')
      this.filter.endAt = val.endDate != null ? this.$moment(val.endDate).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD')
      this.refreshReportCards()
    },
    getSalesChannelDistributionData() {
      let salesChannel = {};

      vm.salesChannelData.forEach(item => {
        if('Overrall' === item['Order Type']) {
          salesChannel[item.Channel] = parseFloat((item['Total Sales'].replace(/\,/g,'')) || 0)  
        }
      })

      const web = salesChannel['Web'] || 0
      const androidApp = salesChannel['Android'] || 0
      const iosApp = salesChannel['iOS'] || 0
      const mobileWeb = salesChannel['Mobile Web'] || 0
      const aggregator = salesChannel['Aggregator'] || 0
      const callCenter = salesChannel['Call Center'] || 0
      const other = salesChannel['Other'] || 0

      const totalSales = web + androidApp + iosApp + mobileWeb + aggregator + callCenter + other
      const salesChannelPercent = {}
      salesChannelPercent['webPercent'] = totalSales > 0 ? ((web/totalSales)*100).toFixed() : 0
      salesChannelPercent['androidAppPercent'] = totalSales > 0 ? ((androidApp/totalSales)*100).toFixed() : 0
      salesChannelPercent['iosAppPercent'] = totalSales > 0 ? ((iosApp/totalSales)*100).toFixed() : 0
      salesChannelPercent['mobileWebPercent'] = totalSales > 0 ? ((mobileWeb/totalSales)*100).toFixed() : 0
      salesChannelPercent['aggregatorPercent'] = totalSales > 0 ? ((aggregator/totalSales)*100).toFixed() : 0
      salesChannelPercent['callCenterPercent'] = totalSales > 0 ? ((callCenter/totalSales)*100).toFixed() : 0
      salesChannelPercent['otherPercent'] = totalSales > 0 ? ((other/totalSales)*100).toFixed() : 0
      const totalPercent = Object.values(salesChannelPercent).reduce((a, b) => parseFloat(a) + parseFloat(b), 0)

      const maxSaleChannel = vm._.max(Object.keys(salesChannelPercent), k => salesChannelPercent[k])
      salesChannelPercent[maxSaleChannel] = salesChannelPercent[maxSaleChannel] > 0 
      ? parseFloat(salesChannelPercent[maxSaleChannel]) + (100 - parseFloat(totalPercent)) : salesChannelPercent[maxSaleChannel]

      let labels = [];
      let data = [web, androidApp, iosApp, mobileWeb, other]
      if(this.isDisplayAggregatorReport()) { data.push(aggregator) }
      if(this.isDisplayCallCenterReport()) { data.push(callCenter) }

      data.sort(function(a, b){return b - a}); //desc
     
      data.forEach((val)=>{
        if(val == web && (labels.indexOf(vm.$t('report.web', { percent: salesChannelPercent.webPercent })) == -1 )) {
          labels.push(vm.$t('report.web', { percent: salesChannelPercent.webPercent }))
        }
        else if(val==androidApp && (labels.indexOf(vm.$t('report.android_app', { percent: salesChannelPercent.androidAppPercent }))  == -1 )) {
          labels.push(vm.$t('report.android_app', { percent: salesChannelPercent.androidAppPercent }))
        }
        else if(val==iosApp && (labels.indexOf(vm.$t('report.ios_app', { percent: salesChannelPercent.iosAppPercent }))  == -1 )) {
          labels.push(vm.$t('report.ios_app', { percent: salesChannelPercent.iosAppPercent }))
        }
        else if(val==mobileWeb && (labels.indexOf(vm.$t('report.mobile_web', { percent: salesChannelPercent.mobileWebPercent }))  == -1 )){
          labels.push(vm.$t('report.mobile_web', { percent: salesChannelPercent.mobileWebPercent }))
        }
        else if(val==aggregator && this.isDisplayAggregatorReport() && (labels.indexOf(vm.$t('report.aggregator', { percent: salesChannelPercent.aggregatorPercent }))  == -1 )) {
          labels.push(vm.$t('report.aggregator', { percent: salesChannelPercent.aggregatorPercent }))
        }
        else if(val==callCenter && this.isDisplayCallCenterReport() && (labels.indexOf(vm.$t('report.call_center', { percent: salesChannelPercent.callCenterPercent }))  == -1 ) ) {
          labels.push(vm.$t('report.call_center', { percent: salesChannelPercent.callCenterPercent }))
        }
        else  if(val==other && (labels.indexOf(vm.$t('report.other', { percent: salesChannelPercent.otherPercent }))  == -1 )){
          labels.push(vm.$t('report.other', { percent: salesChannelPercent.otherPercent }))
        }
      });

      vm.salesChannelDistributionChartData = {
        labels,
        datasets : [{
          backgroundColor: ['#EAF6ED','#DBF1E2','#CDEBD6','#B2E1C1','#9FDAB3','#8CD3A4','#67C587'],
          data
        }]
      }
    },
    updateTransactionsData(paymentMethod) {
      const payment_method_with_percentage = []
      const total_payments = [];
      let consolidatedPaymentTotal=0; 
      let consolidatedPaymentLabels=[];
      let consolidatedPaymentPercent = 0;

      paymentMethod.sort((a, b) => parseInt(b.Total.replace(/\,/g,'')) - parseInt(a.Total.replace(/\,/g,'')));
      paymentMethod.forEach(item => {
        const label = `${item['Payment Method']} ${item['In percetage']}`;
        const value = item['Total'].replace(/\,/g,'');  //remove comma
        if(total_payments.length > 5) {
          consolidatedPaymentTotal += parseInt(value);
          consolidatedPaymentPercent += parseInt(item['In percetage'].replace('%', ''));
          consolidatedPaymentLabels.push(label + " : "+value);
        } else {
          payment_method_with_percentage.push(label);
          total_payments.push(value);
        }
      });

      if(consolidatedPaymentTotal > 0) {
        payment_method_with_percentage.push(`${LABEL_OTHERS} ${consolidatedPaymentPercent}%`);
        total_payments.push(consolidatedPaymentTotal);
      }
      
      vm.paymentMethodChartData = {
        labels: payment_method_with_percentage,
        datasets : [{
          label: consolidatedPaymentLabels,
          backgroundColor: ['#67C587','#8CD3A4','#9FDAB3','#B2E1C1','#CDEBD6','#DBF1E2','#EAF6ED'],
          data : total_payments
        }]
      }
    },
    updateDeliveryCarryoutData(deliveryCarryout) {
      let percent_delivery='0%';
      let percent_collection='0%';
      let deliveryTotal=0;
      let collectionTotal=0;

      deliveryCarryout.forEach(item => {
        if(item['Order Type'] == 'Delivery') {
          percent_delivery = item['In percetage'];
          deliveryTotal = item['Total'].replace(/\,/g,'');
        }
        else if(item['Order Type'] == 'Carryout') {
          percent_collection = item['In percetage'];
          collectionTotal = item['Total'].replace(/\,/g,'');
        }
      });

      vm.deliveryAndCollectionChartData = {
        labels: [
          vm.$t('report.delivery', { percent: percent_delivery}),
          vm.$t('report.collection', { percent: percent_collection }),  
        ],
        datasets : [{
          backgroundColor: ['#67C587','#A9DEBA'],
          data : [deliveryTotal, collectionTotal]
        }]
      }
    },
    updateOverviewTableData() {
      let web = {"transaction":0,"sales":0,"AOV":0,"channel":"Web"};
      let ios ={"transaction":0,"sales":0,"AOV":0,"channel":"iOS"} 
      let appAndoid = {"transaction":0,"sales":0,"AOV":0,"channel":"Android"};
      let mobileWeb = {"transaction":0,"sales":0,"AOV":0,"channel":"Mobile Web"};
      let aggregator = {"transaction":0,"sales":0,"AOV":0,"channel":"Aggregator"};
      let callCenter = {"transaction":0,"sales":0,"AOV":0,"channel":"Call Center"};
      let other = {"transaction":0,"sales":0,"AOV":0,"channel":"Other"};
      let totals = {"transaction":0,"sales":0,"AOV":0,"channel": vm.$t('report.total')};

      vm.salesChannelData.forEach( item => {
        if(item['Order Type'] == 'Overrall') {
          if(item.Channel == 'Web') {
            web.transaction = parseInt(item["Total Cheque"].replace(/\,/g,''))
            web.sales = parseFloat(item['Total Sales'].replace(/\,/g,''))
            web.AOV = parseFloat(item['Avg Cheque'].replace(/\,/g,''))
          }
          else if(item.Channel == 'iOS') {
            ios.transaction = parseInt(item["Total Cheque"].replace(/\,/g,''))
            ios.sales = parseFloat(item['Total Sales'].replace(/\,/g,''))
            ios.AOV = parseFloat(item['Avg Cheque'].replace(/\,/g,''))
          }
          else if(item.Channel == 'Android') {
            appAndoid.transaction = parseInt(item["Total Cheque"].replace(/\,/g,''))
            appAndoid.sales = parseFloat(item['Total Sales'].replace(/\,/g,''))
            appAndoid.AOV = parseFloat(item['Avg Cheque'].replace(/\,/g,''))
          }
          else if(item.Channel == 'Android') {
            appAndoid.transaction = parseInt(item["Total Cheque"].replace(/\,/g,''))
            appAndoid.sales = parseFloat(item['Total Sales'].replace(/\,/g,''))
            appAndoid.AOV = parseFloat(item['Avg Cheque'].replace(/\,/g,''))
          }
          else if(item.Channel == 'Mobile Web') {
            mobileWeb.transaction = parseInt(item["Total Cheque"].replace(/\,/g,''))
            mobileWeb.sales = parseFloat(item['Total Sales'].replace(/\,/g,''))
            mobileWeb.AOV = parseFloat(item['Avg Cheque'].replace(/\,/g,''))
          }
          else if(item.Channel == 'Aggregator') {
            aggregator.transaction = parseInt(item["Total Cheque"].replace(/\,/g,''))
            aggregator.sales = parseFloat(item['Total Sales'].replace(/\,/g,''))
            aggregator.AOV = parseFloat(item['Avg Cheque'].replace(/\,/g,''))
          }
          else if(item.Channel == 'Call Center') {
            callCenter.transaction = parseInt(item["Total Cheque"].replace(/\,/g,''))
            callCenter.sales = parseFloat(item['Total Sales'].replace(/\,/g,''))
            callCenter.AOV = parseFloat(item['Avg Cheque'].replace(/\,/g,''))
          }
          else if(item.Channel == 'Other') {
            other.transaction = parseInt(item["Total Cheque"].replace(/\,/g,''))
            other.sales = parseFloat(item['Total Sales'].replace(/\,/g,''))
            other.AOV = parseFloat(item['Avg Cheque'].replace(/\,/g,''))
          }
          totals.transaction += parseInt(item["Total Cheque"].replace(/\,/g,''))
          totals.sales += parseFloat(item['Total Sales'].replace(/\,/g,''))
        }
      });
      //Refactor
      totals.sales = totals.sales.toFixed(2);
      totals.AOV = vm.aov_value;
      //push
      vm.overviewTableData.items = [];
      vm.overviewTableData.items.push(web);
      vm.overviewTableData.items.push(ios);
      vm.overviewTableData.items.push(appAndoid);
      vm.overviewTableData.items.push(mobileWeb);
      if(this.isDisplayAggregatorReport()) {
        vm.overviewTableData.items.push(aggregator);
      }
      if(this.isDisplayCallCenterReport()) {
        vm.overviewTableData.items.push(callCenter);
      }
      vm.overviewTableData.items.push(other);
      vm.overviewTableData.items.push(totals);
    },
    updateComparedToPreviousYearChartData() {
      vm.comparedToPreviousYearChartData = {}; 
      if(vm.salesChannelData.length == undefined || (vm.previousYearData.mobile_desktop.length===0)) {
        return;
      }

      let currentYear = {};
      let previousYear = {};
      let key, label_total;
      
      if(vm.previousYearOptionSelected.name == TOTAL_CHEQUE) {
        key = TOTAL_CHEQUE;
        currentYear.total = parseFloat(vm.total_transactions.replace(/\,/g,'')); //remove comma
        previousYear.total = vm.previousYearData.summary.totalCheque;
        if(vm.$session.get('lang') === 'ja') {
          label_total = [vm.$t('report.label_total_transactions')];
        } else {
          label_total = [vm.$t('report.total'), vm.$t('report.label_transactions')];
        }
      } 
      else if(vm.previousYearOptionSelected.name == TOTAL_SALE) {
        key = TOTAL_SALE;
        currentYear.total = parseFloat(vm.total_sales.replace(/\,/g,''));
        previousYear.total = vm.previousYearData.summary.totalSales;
        label_total = [vm.$t('report.label_total_sales')];
      } 
      else if(vm.previousYearOptionSelected.name == AVG_CHEQUE) {
        key = AVG_CHEQUE;
        currentYear.total = parseFloat(vm.aov_value.replace(/\,/g,''));
        previousYear.total = vm.previousYearData.summary.avg;
        label_total = [vm.$t('report.label_total_aov')];
      }
      
      vm.salesChannelData.forEach(item => {
        currentYear[item.Channel] = parseFloat(item[key].replace(/\,/g,'') || 0)  
      })

      vm.previousYearData.mobile_desktop.forEach(item => {
        previousYear[item.Channel] = parseFloat(item[key].replace(/\,/g,'') || 0)  
      })

      let labelCurrentYear = this.$moment(this.filter.startAt).format('YYYY/MM/DD')+' - '+this.$moment(this.filter.endAt).format('YYYY/MM/DD');
      let labelPreviousYear = this.$moment(this.filter.startAt).subtract(1, 'years').format('YYYY/MM/DD')+' - '+this.$moment(this.filter.endAt).subtract(1, 'years').format('YYYY/MM/DD'); //.subtract(1, 'months')

      let labels = [vm.$t('report.label_web'), vm.$t('report.label_ios_app'), vm.$t('report.label_android_app'), vm.$t('report.label_mobile_web')]
      let currentYearData = [currentYear.Web, currentYear.iOS, currentYear.Android, currentYear['Mobile Web']]
      let previousYearData = [previousYear.Web, previousYear.iOS, previousYear.Android, previousYear['Mobile Web']]
      if(this.isDisplayAggregatorReport()) {
        labels.push(vm.$t('report.label_aggregator'))
        currentYearData.push(currentYear['Aggregator'])
        previousYearData.push(previousYear['Aggregator'])
      }
      if(this.isDisplayCallCenterReport()) {
        labels.push(vm.$t('report.label_call_center'))
        currentYearData.push(currentYear['Call Center'])
        previousYearData.push(previousYear['Call Center'])
      }
      labels.push(vm.$t('report.label_other'))
      labels.push(label_total)
      currentYearData.push(currentYear.Other)
      currentYearData.push(currentYear.total)
      previousYearData.push(previousYear.Other)
      previousYearData.push(previousYear.total)

      //Chart data
      vm.comparedToPreviousYearChartData = {
        labels,
        datasets: [{
            label:labelCurrentYear,
            backgroundColor: "#038900",
            data: currentYearData
        }, {
            label:labelPreviousYear,
            backgroundColor: "#67C587",
            data: previousYearData
        }]
      };

      const { current, previous } = vm.computedCurrentAndPreviousYear(currentYear, previousYear, key)

      //Bar graph Right side labels
      vm.computedLabelsForPreviousYearChart['Web'] = {
        current: current.Web.toFixed() + '% - ' + currentYear.Web,
        previous: previous.Web.toFixed() + '% - ' + previousYear.Web
      };
      vm.computedLabelsForPreviousYearChart['Android App'] = {
        current: current.Android.toFixed() + '% - ' + currentYear.Android,
        previous: previous.Android.toFixed() + '% - ' + previousYear.Android
      };
      vm.computedLabelsForPreviousYearChart['iOS App'] = {
        current: current.iOS.toFixed() + '% - ' + currentYear.iOS,
        previous: previous.iOS.toFixed() + '% - ' + previousYear.iOS
      };
      vm.computedLabelsForPreviousYearChart[label_total] = {
        current: currentYear.total,
        previous: previousYear.total
      };

      if(this.isDisplayAggregatorReport()) {
        vm.computedLabelsForPreviousYearChart['Aggregator'] = {
          current: current['Aggregator'].toFixed() + '% - ' + currentYear['Aggregator'],
          previous: previous['Aggregator'].toFixed() + '% - ' + previousYear['Aggregator']
        };
      }
      if(this.isDisplayCallCenterReport()) {
        vm.computedLabelsForPreviousYearChart['Call Center'] = {
          current: current['Call Center'].toFixed() + '% - ' + currentYear['Call Center'],
          previous: previous['Call Center'].toFixed() + '% - ' + previousYear['Call Center']
        };
      }
      vm.computedLabelsForPreviousYearChart['Mobile Web'] = {
        current: current['Mobile Web'].toFixed() + '% - ' + currentYear['Mobile Web'],
        previous: previous['Mobile Web'].toFixed() + '% - ' + previousYear['Mobile Web']
      };
      vm.computedLabelsForPreviousYearChart['Other'] = {
        current: current.Other.toFixed() + '% - ' + currentYear.Other,
        previous: previous.Other.toFixed() + '% - ' + previousYear.Other
      };
    },
    computedCurrentAndPreviousYear(currentYear, previousYear, key) {
      let saleChannels = ['Web', 'Android', 'iOS', 'Mobile Web', 'Other']
      if(this.isDisplayAggregatorReport()) {
        saleChannels.push('Aggregator')
      }
      if(this.isDisplayCallCenterReport()) {
        saleChannels.push('Call Center')
      }
      saleChannels.push('Other')
      let current = {}
      let previous = {}
      let currentTotalPercent = 0
      let previousTotalPercent = 0
      let currentMaxPercent = saleChannels[0]
      let previousMaxPercent = saleChannels[0]
      saleChannels.forEach(saleChannel => {
        current[saleChannel] = currentYear.total > 0 ? parseFloat((((+currentYear[saleChannel]) / currentYear.total) * 100).toFixed()) : 0
        currentTotalPercent += current[saleChannel]
        currentMaxPercent = current[saleChannel] > current[currentMaxPercent] ? saleChannel : currentMaxPercent
        previous[saleChannel] = previousYear.total > 0 ? parseFloat((((+previousYear[saleChannel]) / previousYear.total) * 100).toFixed()) : 0
        previousTotalPercent += previous[saleChannel]
        previousMaxPercent = previous[saleChannel] > previous[currentMaxPercent] ? saleChannel : previousMaxPercent
      })
      if (key != AVG_CHEQUE) {
        current[currentMaxPercent] = current[currentMaxPercent] > 0 ? (current[currentMaxPercent] + (100 - currentTotalPercent)) : 0
        previous[previousMaxPercent] = previous[previousMaxPercent] > 0 ? (previous[previousMaxPercent] + (100 - previousTotalPercent)) : 0
      }
      return { current, previous }
    },
    prepareDataForExport(summary, salesChannelData, paymentMethodData, deliveryCarryoutData) {
      this.reportExportData=[];
      if (this.reportExportData.length == 0){
        this.reportExportData.push({
          OrderSummaryCategory: '',
          TotalSale: summary.totalSales,
          TotalCheque: summary.totalCheque,
          AverageCheque: summary.avg,
          OSDSeparator1: '',
          OrderSummaryDetailsCategory: '',
          OrderType: salesChannelData[0]['Order Type'],
          Device: salesChannelData[0]['Channel'],
          TotalDetailCheque: salesChannelData[0]['Total Cheque'],
          TotalDetailSale: salesChannelData[0]['Total Sales'],
          TotalDetailAvgCheque: salesChannelData[0]['Avg Cheque'],
          OSDSeparator2: '',
          ChannelCategory: '',
          COrderType: deliveryCarryoutData[0]['Order Type'],
          CTotal: deliveryCarryoutData[0]['Total'],
          CInPercentage: deliveryCarryoutData[0]['In percetage'],
          OSDSeparator3: '',
          OrderSummaryPmDetailsCategory: '',
          PaymentMethodName: paymentMethodData[0]['Payment Method'],
          PaymentMethodTotal: paymentMethodData[0]['Total'],
          PaymentMethodInPercentage: paymentMethodData[0]['In percetage']
        });
      }
      for (let i = 1; i < salesChannelData.length; i++) {
        if((!this.isDisplayAggregatorReport() && 'Aggregator' == salesChannelData[i]['Channel'])
        ||(!this.isDisplayCallCenterReport() && 'Call Center' == salesChannelData[i]['Channel'])) {
          continue;
        }
        this.reportExportData.push({ 
          OrderSummaryCategory: '',
          TotalSale: '',
          TotalCheque: '',
          AverageCheque: '',
          OSDSeparator1: '',
          OrderSummaryDetailsCategory: '',
          OrderType: salesChannelData[i]['Order Type'],
          Device: salesChannelData[i]['Channel'],
          TotalDetailCheque: salesChannelData[i]['Total Cheque'],
          TotalDetailSale: salesChannelData[i]['Total Sales'],
          TotalDetailAvgCheque: salesChannelData[i]['Avg Cheque'],
          OSDSeparator2: '',
          ChannelCategory: '',
          COrderType: '',
          CTotal: '',
          CInPercentage: '',
          OSDSeparator3: '',
          OrderSummaryPmDetailsCategory: '',
          PaymentMethodName: '',
          PaymentMethodTotal: '',
          PaymentMethodInPercentage: ''
        });
      }
      for (let i = 1; i < paymentMethodData.length; i++) {
        if(this.reportExportData[i] !== undefined) {
          this.reportExportData[i].PaymentMethodName = paymentMethodData[i]['Payment Method']
          this.reportExportData[i].PaymentMethodTotal = paymentMethodData[i]['Total']
          this.reportExportData[i].PaymentMethodInPercentage = paymentMethodData[i]['In percetage']
        } else {
          this.reportExportData.push({ 
            OrderSummaryCategory: '',
            TotalSale: '',
            TotalCheque: '',
            AverageCheque: '',
            OSDSeparator1: '',
            OrderSummaryDetailsCategory: '',
            OrderType: '',
            Device: '',
            TotalDetailCheque: '',
            TotalDetailSale: '',
            TotalDetailAvgCheque: '',
            OSDSeparator2: '',
            ChannelCategory: '',
            COrderType: '',
            CTotal: '',
            CInPercentage: '',
            OSDSeparator3: '',
            OrderSummaryPmDetailsCategory: '',
            PaymentMethodName: paymentMethodData[i]['Payment Method'],
            PaymentMethodTotal: paymentMethodData[i]['Total'],
            PaymentMethodInPercentage: paymentMethodData[i]['In percetage']
          });
        }
      }
      for (let i = 1; i < deliveryCarryoutData.length; i++) {
        if(this.reportExportData[i] !== undefined) {
          this.reportExportData[i].COrderType = deliveryCarryoutData[i]['Order Type']
          this.reportExportData[i].CTotal = deliveryCarryoutData[i]['Total']
          this.reportExportData[i].CInPercentage = deliveryCarryoutData[i]['In percetage']
        } else {
          this.reportExportData.push({ 
            OrderSummaryCategory: '',
            TotalSale: '',
            TotalCheque: '',
            AverageCheque: '',
            OSDSeparator1: '',
            OrderSummaryDetailsCategory: '',
            OrderType: '',
            Device: '',
            TotalDetailCheque: '',
            TotalDetailSale: '',
            TotalDetailAvgCheque: '',
            OSDSeparator2: '',
            ChannelCategory: '',
            COrderType: deliveryCarryoutData[i]['Order Type'],
            CTotal: deliveryCarryoutData[i]['Total'],
            CInPercentage: deliveryCarryoutData[i]['In percetage'],
            OSDSeparator3: '',
            OrderSummaryPmDetailsCategory: '',
            PaymentMethodName: '',
            PaymentMethodTotal: '',
            PaymentMethodInPercentage: ''
          });
        }
      }
    },
    getOutletList() {
      let vm = this
      vm.axios.campaign.getStoreListFullDetails(function (response) {
        vm.allStoresList = response.data.data.items;
        vm.allStoresList.map(item => {
          item.name_en = `${item.code} - ${item.name.en}`;
        })
      });
    },
    getSpanText(item) {
      return ` ${item.length } options selected`;
    },
    isDisplayAggregatorReport() {
      const config = vm.$session.get('config');
      const manualConfig = vm._.get(config, 'manual_config', {}) || {};
      if(manualConfig.display_aggregator_report && manualConfig.display_aggregator_report == true) {
        return true
      }
      return false
    },
    isDisplayCallCenterReport() {
      const config = vm.$session.get('config');
      const manualConfig = vm._.get(config, 'manual_config', {}) || {};
      if(manualConfig.display_callcenter_report && manualConfig.display_callcenter_report == true) {
        return true
      }
      return false
    },
    useNewApiNewSaleReport() {
      const config = vm.$session.get('config');
      const manualConfig = vm._.get(config, 'manual_config', {}) || {};
      if(manualConfig.use_new_api_sale_report && manualConfig.use_new_api_sale_report == true) {
        return true
      }
      return false
    },
    loadDataFromAPI(data) {
      vm.summary = data.summary
      vm.delivery_carryout = data.delivery_carryout;
      vm.payment_method = data.payment_method;
      vm.salesChannelData = data.mobile_desktop;
      vm.previousYearData = data.previous_year;
      vm.aov_value = vm.formatPrice(vm.summary.avg)
      vm.total_sales = vm.formatPrice(vm.summary.totalSales)
      vm.total_transactions = vm.formatPrice(vm.summary.totalCheque)
      vm.loadReportCards();
    }
  },
  computed: {
    date_locale: function () {
      let format = this.format_date_range_locale();
      format.format = 'YYYY/MM/DD';
      if (this.$refs.drange) {
        this.$refs.drange.locale = format
      }
      return format
    },
    ranges: function () {
      return this.format_date_ranges()
    }
  },
  created : function () {
    vm=this;
    vm.useNewAPI = vm.useNewApiNewSaleReport()
    vm.getNewSalesReportData();
    vm.newSaleReportChangeLang = () => {
      if(vm.delivery_carryout !== null && vm.payment_method !== null && vm.summary!== null) {
        vm.loadReportCards();
      }
    }
    vm.$root.$on('changeLang', vm.newSaleReportChangeLang)
  },
  beforeDestroy() {
    vm.$root.$off('changeLang',vm.newSaleReportChangeLang)
  },
  watch : {
    selectedOutlets : function () {
      this.refreshReportCards();
    }
  }
}

</script>
<style scoped>
.sales-report-list ::selection{
  background-color: #d7d7d7 !important;
  color: #000;
}
.report-card {
  text-align: center
}
.card-details {
  text-align: center;
  font-size: 26px;
}
.card-number-stats{
  font-weight: 700 !important;
  font-size: 38px!important;
  line-height: 32px!important;
}
.card-heading-stats{
  /* font-family: 'Sharp Sans Display No1'; */
  font-style: normal;
  font-weight: 700 !important;
  font-size: 24px;
  line-height: 28px;
  color: #231F20;
}
.table-text {
  width: 87px;
  height: 24px;
  /* font-family: 'Open Sans'; */
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  color: #333333;
  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;
}
.totals-row {
  font-weight: 700;
  /* font-size: 16px; */
  line-height: 24px;
  color: #333333;
  flex: none;
  order: 1;
  flex-grow: 0;
}
.report-title {
  /* font-family: 'Sharp Sans Display No1'; */
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  display: flex;
  align-items: center; 
} 
.title-green {
  color : #038900;
} 
.title-black {
  color : #000000;
}
.date-range-box-order-sales-reports {
  border: 1px solid #00000026;
  border-radius: 3px;
  width: 70%;
  margin: 0 auto;
}
.date-range-text {
  font-size: 12px;
  margin-left: 10px;
  width: max-content;
  color:#6B6E79;
  margin-bottom: -3px;
}
.btn-success{
  color: #fff;
  background-color: #0A8020 !important;
  border-color: #4dbd74;
  font-size: 0.95rem;
}
.bar-chart-select-option{
  margin: 0 auto;
  display: -webkit-inline-box;
}
</style>
<style>
.md-table-head{
    color: #000000 !important;
}

.date-range-box-order-sales-reports > .input-group > div > div.form-control {
    border: none !important;
}

.md-table-head-label {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
}

.sales-report-list .last-row .md-card {
  height: 100% !important;
}

.sales-report-list .last-row .md-table-content {
  margin-top: 3em;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .sales-report-list .sales-hut-selection .multiselect__tags{
      max-width: 94% !important;
      min-width: 94% !important;
  }
  .sales-report-list .sales-hut-selection .multiselect__select {
    right: 30px !important;
  }
  .sales-report-list .sales-hut-selection .multiselect__content-wrapper {
    width: 94% !important;
  }
  .bar-chart-select-option .multiselect__tags {
    max-width: 220px;
    min-width: 220px;
  }
</style>


// WEBPACK FOOTER //
// src/views/admin/report/SalesReportKW.vue